import { Injectable } from '@angular/core';
import { RequestOptions, Headers } from '@angular/http';
import { SnrResponseJustification, SnrResponseJustificationCollection, SnrResponseJustificationPost } from 'ri-api-client';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { ApiService } from '../api.service';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigService } from '../../../app/config.service';
import { OAuthService } from 'angular-oauth2-oidc';


  interface SnrDisconnectionFilterCollection {
      'results'?: {
          'id'?: number;
          'open_debt_min_value'?: string;
          'open_debt_max_value'?: string;
          [k: string]: any;
      }[];
      'totalCount'?: number;
      [k: string]: any;
  }


@Injectable()
export class SnrResponseJustificationService {
  private requestHeaders: any;
  BASE_URL = ConfigService.app.baseUri;


  constructor(
    private apiService: ApiService,
    private oAuth: OAuthService,
    private httpClient: HttpClient,
  ) {
    this.apiService.init();
    this.requestHeaders = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.oAuth.getAccessToken()}`
    }
  }

  get(): Observable<SnrResponseJustificationCollection.SnrResponseJustificationCollection> {
    return this.apiService.client.serviceNoteRequests.responseJustifications.GET()
      .map((res) => {
        return this.apiService.handleResponse(res);
      });
  }

  getById(id: number): Observable<any> {
    return this.apiService
                .client
                .serviceNoteRequests
                .responseJustifications
                .idSnrResponseJustification(id.toString())
                .GET()
                .map((res) => {
                  return this.apiService.handleResponse(res);
                });
  }

  post(justification: SnrResponseJustificationPost.SnrResponseJustificationPost): Observable<any[]> {
    const headers = new Headers({ 'Content-Type': 'application/json'});
    const options = new RequestOptions({ headers: headers });

    return this.apiService
                .client
                .serviceNoteRequests
                .responseJustifications.POST(justification, options)
      .map((res) => {
        return this.apiService.handleResponse(res);
      });
  }

  update(id: Number, justification: SnrResponseJustification.SnrResponseJustification): Observable<any[]> {
      return this.apiService
                .client
                .serviceNoteRequests
                .responseJustifications
                .idSnrResponseJustification(id.toString())
                .PATCH(justification)
                .map((res) => {
          return this.apiService.handleResponse(res);
        });
  }

  delete(id: Number): Observable<any[]> {
    return this.apiService
                .client
                .serviceNoteRequests
                .responseJustifications
                .idSnrResponseJustification(id.toString())
                .DELETE()
                .map((res) => {
                  return this.apiService.handleResponse(res);
                });
  }

   // API's for service disconnection filters

   getAllServiceDisconnectionFilters(): Observable<SnrDisconnectionFilterCollection> {
    const resourceUrl = `${this.BASE_URL}/service-note-requests/service-disconnection-filters`;
    return this.httpClient.get<SnrDisconnectionFilterCollection[]>(resourceUrl, { headers: new HttpHeaders(this.requestHeaders) });
  }

  createServiceDisconnectionFilter(disconnectionFilter: any): Observable<any> {
    return this.httpClient.post(`${this.BASE_URL}/service-note-requests/service-disconnection-filters`
      , JSON.stringify(disconnectionFilter)
      , { headers: new HttpHeaders(this.requestHeaders) });
  }

  updateServiceDisconnectionFilter(id: number, disconnectionFilter: any): Observable<any> {
    return this.httpClient.patch(`${this.BASE_URL}/service-note-requests/service-disconnection-filters/${id}`
      , JSON.stringify(disconnectionFilter)
      , { headers: new HttpHeaders(this.requestHeaders) });
  }

  deleteServiceDisconnectionFilter(id): Observable<any> {
    return this.httpClient.delete(`${this.BASE_URL}/service-note-requests/service-disconnection-filters/${id}`, { headers: new HttpHeaders(this.requestHeaders) });
  }
}



// WEBPACK FOOTER //
// ./src/app/core/api/snr-response-justification.service.ts